<template>
    <div class="back-button">
        <b-button @click="goBack">
            <font-awesome-icon :icon="['fas', 'chevron-left']"/>
            Zurück
        </b-button>
    </div>
</template>

<script>
    export default {
        name: "BackButton",
        props: {
            interestsUrl: String
        },
        methods: {
            goBack: function () {
                this.$router.go(-1)
            }
        }
    }
</script>

<style scoped>

</style>